import { useAppLocation } from '@crm/hooks/useAppLocation'
import { useAppNavigate } from '@crm/hooks/useAppNavigate'
import { useRolePermission } from '@crm/hooks/useRolePermission'
import { paths } from '@crm/routes'
import { UserRoleCRM } from '@crm/types/userRoleCrm'
import { useLocales } from '@shared/locales'
import { type TabsProps, Card, Tabs } from 'antd'
import { Outlet, useParams } from 'react-router-dom'

type Props = {
  excludeTabs?: string[]
}

export const InfoTabs = ({ excludeTabs }: Props) => {
  const { t } = useLocales()
  const { id } = useParams()
  const { pathname } = useAppLocation()
  const navigate = useAppNavigate()
  const isAdmin = useRolePermission([UserRoleCRM.admin])

  const items: TabsProps['items'] = [
    {
      key: paths.leadsDetails.root(id),
      label: t('lead.activity')
    },
    {
      key: paths.leadsDetails.opportunities(id),
      label: t('lead.opportunities')
    },
    {
      key: paths.leadsDetails.contracts(id),
      label: t('lead.contracts')
    },
    {
      key: paths.leadsDetails.tasks(id),
      label: t('lead.tasks')
    },
    {
      key: paths.leadsDetails.documents(id),
      label: t('lead.documents')
    },
    {
      key: paths.leadsDetails.contacts(id),
      label: t('lead.contacts')
    },
    ...(isAdmin
      ? [
          {
            key: paths.leadsDetails.campaigns(id),
            label: t('lead.campaigns')
          }
        ]
      : [])
  ].filter(({ key }) => !excludeTabs?.includes(key))

  const onChangeTab = (activeKey: string) => navigate(activeKey)

  return (
    <Card variant="borderless">
      <Tabs
        destroyOnHidden
        activeKey={pathname || items[0]?.key}
        onChange={onChangeTab}
        items={items}
      />

      <Outlet />
    </Card>
  )
}
